import Swiper from "swiper";
import { A11y, FreeMode, Parallax } from "swiper/modules";
import { fireEvent } from "@/scripts/common/util";
import "./services.css";

document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".services-slider .swiper");
  const slides = container.querySelectorAll(".swiper-slide");

  new Swiper(container, {
    modules: [A11y, FreeMode, Parallax],
    slidesPerView: "auto",
    spaceBetween: 0,
    parallax: true,
    slidesOffsetBefore: slides[0].offsetWidth / -2,
    freeMode: {
      enabled: true,
      momentumRatio: 0.6,
    },
    on: {
      sliderFirstMove: (swiper) => {
        if (swiper.params.slidesOffsetBefore !== 0) {
          swiper.params.slidesOffsetBefore = 0;
          swiper.update();
        }
      },
      touchMove: (_, event) => {
        fireEvent("swiper:drag", document.documentElement, event);
      },
      touchEnd: (_, event) => {
        fireEvent("swiper:dragend", document.documentElement, event);
      },
      resize: (swiper) => {
        if (swiper.isLocked) {
          swiper.el.querySelector(".swiper-wrapper").removeAttribute("data-cursor-content");
        } else {
          swiper.el.querySelector(".swiper-wrapper").setAttribute("data-cursor-content", "Drag");
        }
      },
    },
  });
});
